export default __webpack_public_path__ + "static/17-782d365af7443911349e2889d7bb94d9.jpg";